module.exports = "/static/assets/c09a24b9f522a62aafc78f9685f97a98.png";